/**
 * UI variant rollout (PLAN-20260909 for the admin console, PLAN-20260929 for
 * chat). The governance service decides which shell a member sees in both
 * apps; since agion/Agion#3210 it answers `next` with no switch for every
 * member of an unlocked environment and `legacy` only in a locked one. The
 * browser starts on `next` and renders `legacy` only on a valid server answer
 * of `legacy`; it never chooses an interface by itself.
 */
export type UIVariant = 'legacy' | 'next'

export type UIVariantRolloutLevel = 'off' | 'default-next' | 'next-only'

export interface UIVariantResolution {
  organizationId: string
  effectiveVariant: UIVariant
  canSwitch: boolean
  policyLevel: UIVariantRolloutLevel
  policyRevision: number
  userChoice?: UIVariant
  environmentLocked: boolean
  code: string
}

/** The resolution call never holds boot longer than this. */
export const UI_VARIANT_RESOLUTION_TIMEOUT_MS = 3000

/**
 * The call an app makes for its variant, through its own API client: GET
 * /v1/governance/ui-variant, bounded by UI_VARIANT_RESOLUTION_TIMEOUT_MS and
 * never retried.
 */
export interface UIVariantService {
  getResolution: (signal?: AbortSignal) => Promise<UIVariantResolution>
}

/** The signed-in member the variant is resolved for; absent ids mean the new interface without a call. */
export interface UIVariantMember {
  id?: string
  organizationId?: string
}
